/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import UserDetails from '../components/UserDetails';
import Button from '../components/Button';
import styled from 'styled-components';
import ContributeProcess from '../components/ContributionProcess';
import { CustomBtn, CenteredContainer } from '../components/Typography';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../components/Routes';
import ContriProcessMobile from '../components/ContributionProcess/ContriProcessMobile';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';
import { SERVICES } from '../components/Services';
import { get } from '../components/ApiHandler/apihandler';
import { contribution_member_frontend_version } from '../utils/versionControl';

const StyleContPro = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
`;

const NoticeText = styled.p`
  font-family: 'Noto Sans';
  font-style: italic;
  font-weight: 600;
  font-size: 18px;
  line-height: 175%;
  text-align: center;
  color: #51a69e;
  white-space: pre-wrap;
  width: 50%;
  @media (max-width: 767px) {
    width: 90%;
    padding: 0 20px;
    font-size: 16px;
  }
`;
const ImportantTextContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 25px 0px 25px;
  background: rgba(252, 170, 232, 0.2);
  background: #fff;
  width: 80%;
  margin: 40px auto 0px;
  border-bottom: 2px solid #464646;
  border-radius: 0px 0px 20px 20px;
  @media (max-width: 767px) {
    width: 95%;
  }
`;
const VariableText = styled.p`
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: ${(props) => props.fontWeight || 400};
  font-size: ${(props) => props.Size || '16px'};
  line-height: ${(props) => props.lineHeight || '150%'};
  text-align: center;
  color: ${(props) => props.color || '#000000'};
  white-space: pre-wrap;
  // width: 50%;
  margin-top: ${(props) => props.marginTop || '0px'};
`;
const Home = () => {
  const navigate = useNavigate();
  const TITLE = 'Make Contribution - BSG Contribution Site';
  const handleClick = () => {
    const isContributionEnabled =
      process.env.REACT_APP_CONTRIBUTION_ENABLED === 'true';

    if (isContributionEnabled) {
      navigate(ROUTES.CONTRIBUTION_FIRST_PAGE);
    } else {
      toast.error('Contribution is not Enabled', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
        closeButton: false,
      });
    }
  };
  useEffect(() => {
    getSettings();
  }, []);
  const showVersionUpdateBanner = () => {
    if (document.getElementById('version-update-banner')) return;

    const overlay = document.createElement('div');
    overlay.id = 'version-update-banner';

    overlay.innerHTML = `
    <div style="
      position:fixed; inset:0; background:rgba(0,0,0,0.55);
      display:flex; align-items:center; justify-content:center;
      z-index:99999; backdrop-filter:blur(6px);
    ">
      <div style="
        background:#fff; width:90%; max-width:420px; border-radius:20px;
        padding:28px; text-align:center;
        box-shadow:0 20px 60px rgba(0,0,0,0.25);
      ">
        <div style="font-size:42px; margin-bottom:12px;">⚠️</div>

        <h2 style="
          margin:0 0 10px;
          font-size:22px;
          color:#0f172a;
        ">
          Session Expired!
        </h2>

        <button
          id="restore-session-btn"
          style="
            width:100%;
            border:none;
            border-radius:12px;
            padding:14px 18px;
            background:#2563eb;
            color:#fff;
            font-size:15px;
            font-weight:700;
            cursor:pointer;
          "
        >
          Click here to restore session
        </button>
      </div>
    </div>
  `;

    document.body.appendChild(overlay);

    const btn = document.getElementById('restore-session-btn');

    if (btn) {
      btn.onclick = () => {
        window.location.href = `${window.location.origin}?v=${Date.now()}`;
      };
    }
  };
  const getSettings = async () => {
    try {
      const response = await get(SERVICES.GET_SETTINGS);

      if (response && response.ok) {
        const data = await response.json();

        const settingsData = data?.data || [];

        const versionSetting = settingsData.find(
          (item) => item.key === 'contribution_member_frontend_version'
        );

        const CURRENT_VERSION = contribution_member_frontend_version;

        console.log(
          'API Version:',
          versionSetting?.value,
          'Current Version:',
          CURRENT_VERSION
        );

        if (
          versionSetting &&
          versionSetting.value.trim() !== CURRENT_VERSION.trim()
        ) {
          showVersionUpdateBanner();
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <UserDetails />
      <CustomBtn marginTop="50px" onClick={handleClick}>
        <Button>Click here to Contribute</Button>
      </CustomBtn>
      <ImportantTextContainer>
        <VariableText color="#282828" lineHeight="175%" fontWeight="500">
          <span style={{ color: '#009cbf' }}>Important-</span> Please check your
          Name and Address displayed above, to ensure that they are correct. As
          the Contribution Receipt will be generated on the same. In case they
          are not correct. Please DO NOT proceed, and contact your District
          Stats Coordinator or District Leader for getting the corrections made.
          Please make the contributions only after the corrections have been
          done.
        </VariableText>
      </ImportantTextContainer>
      <StyleContPro>
        <ContributeProcess />
      </StyleContPro>
      <ContriProcessMobile />
      <CenteredContainer
        marginBottom="30px"
        style={{
          width: '80%',
          borderRadius: '20px',
          marginLeft: 'auto',
          marginRight: 'auto',
          background: '#ffdede',
        }}
      >
        <NoticeText
          style={{
            fontWeight: '600',
            fontSize: '16px',
            lineHeight: '175%',
            textAlign: 'center',
            color: '#c30000',
            whiteSpace: 'pre-wrap',
            width: '90%',
            '@media(max-width:767px)': {
              fontSize: '16px',
              width: '90%',
            },
          }}
        >
          “FOREIGN NATIONAL MEMBERS ARE NOT ALLOWED TO USE THIS SITE FOR MAKING
          CONTRIBUTION. IF ANY FOREIGN NATIONAL MEMBERS MAKES CONTRIBUTION
          THROUGH THIS SITE, BSG WOULD NOT ACCEPT THEIR CONTRIBUTION.”
        </NoticeText>
      </CenteredContainer>
    </div>
  );
};

export default Home;
